import { Star } from "lucide-react";
import { ModalBackdrop } from "./ModalBackdrop";
import { useEscapeKey } from "./useEscapeKey";
import { SITE_GUIDE } from "../catalogs/site-guide";

/**
 * >>> **HOW TO MOVE THROUGH THE HOUSE — THE ONE GUIDE A MEMBER OPENS, AND THE ONLY SURFACE THAT
 * TEACHES HER WHAT THIS SITE IS (R8's ledger, paid by FF1-BRIDGE, 2026-08-23).** <<<
 *
 * It came out because the R8 ceiling had to be paid and this is the payment that buys the most:
 * inside an eleven-thousand-line shell **this whole surface was reachable by a regex and nothing
 * else**, so *does the guide still list every room a member can reach* was a question no instrument
 * could ask. Out here a gate IMPORTS it and reads the tree it builds from `SITE_GUIDE`.
 *
 * **IT COST NO CASCADE, WHICH IS WHY IT WAS THE ONE TO MOVE (R8: opportunistic, never a big-bang
 * rewrite).** All four of its dependencies were already importable modules — `ModalBackdrop`,
 * `useEscapeKey`, `SITE_GUIDE` and one lucide icon — so nothing had to be dragged out behind it, and
 * **the `SITE_GUIDE` import was cut from the shell in the same commit** (R8's own ledger rule: an
 * extraction that leaves its imports behind pays the ceiling rather than paying it down).
 *
 * It holds ONE hook (`useEscapeKey`), so it is the `TierCards` / `MicButton` / `SignInModal` class
 * rather than a hookless leaf a gate CALLS — **the reach it buys is the IMPORT.** Moved VERBATIM: not
 * one member-visible character changed.
 */
export function SiteInstructions({ onClose }: { onClose: () => void }) {
  useEscapeKey(onClose);
  return (
    <ModalBackdrop label="Site instructions" className="site-instructions-backdrop">
      <div className="site-instructions">
        <button className="modal-close" type="button" onClick={onClose} aria-label="Close site instructions">x</button>
        <p className="eyebrow">A little guide</p>
        <h2>How to move through the house</h2>
        <div className="site-instructions__sections">
          {SITE_GUIDE.map((s) => (
            <section key={s.heading} className={s.star ? "site-instructions__section site-instructions__section--star" : "site-instructions__section"}>
              <h3>{s.star ? <><Star size={16} /> {s.heading}</> : s.heading}</h3>
              <p>{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </ModalBackdrop>
  );
}
